import { render } from "./SectionB.vue?vue&type=template&id=d4e7bcf2&scoped=true"
import script from "./SectionB.vue?vue&type=script&lang=js"
export * from "./SectionB.vue?vue&type=script&lang=js"

import "./SectionB.vue?vue&type=style&index=0&id=d4e7bcf2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4e7bcf2"]])

export default __exports__